module.exports = __webpack_public_path__ + "img/posteIconGrey.34688611.svg";